export default "__VITE_ASSET__CORC83cJ__"